// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"styles_text-gradient__2oDzG","iconLinks":"styles_iconLinks__e5Iq8"};